import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaBooleanDefinition } from './TypedDefinition'

export const SchemaBooleanPlugin = createSchemaPlugin(
  'Schema.Boolean',
  SchemaBooleanDefinition
)
